{
  "aboutProject": "Om prosjektet",
  "accountSettings": "Kontoinnstillinger",
  "activities": "Aktiviteter",
  "activity": "Aktiviteter",
  "application": "Søknad",
  "areasOfInterest": "Interesseområder",
  "chooseCluster": "Velg nettverk",
  "cluster": "Klyngen",
  "clusterManagement": "Ledelse",
  "clusterOperation": "Klyngedrift",
  "clusterVisionMission": "Nettverkets visjon og misjon",
  "companyInformation": "Selskapsinformasjon",
  "contactInformation": "Kontaktinformasjon",
  "contacts": "Kontakter",
  "coreData": "Grunndata",
  "economy": "Økonomi",
  "events": "Eventer",
  "financing": "Finansiering",
  "focusAreas": "Fokusområder",
  "goalAccomplishment": "Årets måloppnåelse",
  "graphical": "Lag en egen inngang til Én vei inn",
  "home": "Hjem",
  "hourlyRate": "Timesats",
  "ideasAndCompanies": "Idéer og bedrifter",
  "ideasAndCompaniesHeader": "Arbeide med idéer, bedrifter og alumni",
  "inFinancedProjects": "Prosjekter finansiert av Innovasjon Norge",
  "mainGoal": "Hovedmål",
  "memberCompanySelfEffortOverview": "Oversikt over medlemsbedriftens egeninnsats",
  "memberInformation": "Medlemsinformasjon",
  "customers": "Kunder",
  "membershipFee": "Medlemskontigent",
  "membershipFeesAndSelfEffort": "Medlemsbidrag og egeninnsats",
  "opportunities": "Henvendelser",
  "opportunitiesHeader": "Behandle henvendelser fra kunder",
  "overview": "Oversikt",
  "ownProjects": "Egne prosjekter",
  "participants": "Deltagere",
  "portal": "Flerbedriftsportalen",
  "projectCategories": "Prosjektkategorier",
  "projectDetail": "Prosjektdetaljer",
  "Projects": "Prosjekter",
  "projects": "Prosjekt",
  "reports": "Rapporter",
  "resourceBase": "Kunderegister",
  "selfEffort": "Egeninnsats",
  "selfEffortContactOverview": "Oversikt over kontaktens egeninnsats",
  "selfEffortOverview": "Oversikt egeninnsats",
  "statistics": "Statistikk",
  "subProjects": "Delprosjekter",
  "visionMission": "Visjon og misjon",
  "yourProfile": "Profilen din",
  "assignments": "Oppgaver",
  "allMeetings": "Alle møter",
  "allEvents": "Alle eventer",
  "sivaContacts": "Kontakter",
  "sivaReporting": "Rapportering",
  "sivaReporting.Header": "Rapportere og følge opp",
  "sivaReporting.Budgets": "Budsjett og revisorbekreftelse",
  "sivaReporting.GoalNumber": "Måltall",
  "sivaReporting.AchievedGoals": "Måloppnåelse",
  "sivaReporting.Spending": "Tildeling og bruk av midler",
  "sivaReporting.SelfDeclaration": "Egenerklæring",
  "sivaDataExtract": "Datauttrekk",
  "myContactInformation": "Min kontaktinfo",
  "editMyContactInformation": "Rediger min kontaktinformasjon",
  "actorProfile": "Aktørprofil",
  "settings": "Innstillinger",
  "accessControls": "Tilgangsstyring",
  "editAccessControls": "Rediger tilganger",
  "mailSettings": "E-postvarsler",
  "editMailSettings": "Rediger e-postvarsler",
  "targetedCompanies": "Målbedrifter",
  "frontPage": "Forside",
  "services": "Tjenestekatalog",
  "services.Header": "Se og registrere tjenester",
  "invoices": "Fakturering"
}
